export const AUTH = {
	LOGIN: 'LOGIN',
	LOGOUT: 'LOGOUT',
	SET_ALL_EXAMS: 'SET_ALL_EXAMS',
	SET_PAST_EXAMS: 'SET_PAST_EXAMS',
	SET_CURRENT_USER: 'SET_CURRENT_USER',
	SET_COURSES: 'SET_COURSES'
}

export const DRAWER = {
    DRAWER_OPEN: 'DRAWER_OPEN',
    DRAWER_CLOSED: 'DRAWER_CLOSED'
}

export const INIT = {
	INIT: 'INIT'
}

export const QUESTIONS = {
	ADD_QUESTION: 'ADD_QUESTION',
	SET_QUESTION: 'SET_QUESTION',
	SET_ANSWER: 'SET_ANSWER',
	SET_QUESTION_TYPE: 'SET_QUESTION_TYPE',
	REMOVE_QUESTION: 'REMOVE_QUESTION',
	SWAP_QUESTION: 'SWAP_QUESTION',
	ADD_OPTION: 'ADD_OPTION',
	SET_OPTION: 'SET_OPTION',
	REMOVE_OPTION: 'REMOVE_OPTION',
	TOGGLE_QUESTION_BOLD_FLAG: 'TOGGLE_QUESTION_BOLD_FLAG',
	TOGGLE_QUESTION_ITALIC_FLAG: 'TOGGLE_QUESTION_ITALIC_FLAG',
	TOGGLE_QUESTION_UNDERLINE_FLAG: 'TOGGLE_QUESTION_UNDERLINE_FLAG',
	TOGGLE_QUESTION_MODAL: 'TOGGLE_QUESTION_MODAL',
	TOGGLE_OPTION_BOLD_FLAG: 'TOGGLE_OPTION_BOLD_FLAG',
	TOGGLE_OPTION_ITALIC_FLAG: 'TOGGLE_OPTION_ITALIC_FLAG',
	TOGGLE_OPTION_UNDERLINE_FLAG: 'TOGGLE_OPTION_UNDERLINE_FLAG',
	TOGGLE_OPTION_MODAL: 'TOGGLE_OPTION_MODAL',
	SET_QUESTION_IMG_SRC: 'SET_QUESTION_IMG_SRC',
	SET_QUESTION_ALTERNATIVE: 'SET_QUESTION_ALTERNATIVE',
	SET_QUESTION_HEIGHT: 'SET_QUESTION_HEIGHT',
	SET_QUESTION_WIDTH: 'SET_QUESTION_WIDTH',
	SET_OPTION_IMG_SRC: 'SET_OPTION_IMG_SRC',
	SET_OPTION_ALTERNATIVE: 'SET_OPTION_ALTERNATIVE',
	SET_OPTION_HEIGHT: 'SET_OPTION_HEIGHT',
	SET_OPTION_WIDTH: 'SET_OPTION_WIDTH'
}
